/**
 * The bookmark colour palette, the 15 swatches of the Unity editor's "CompositeBox - BookmarkColorSelector"
 * (BookmarkColorChangeFunctions.cs), in its order. A bookmark stores the 0xRRGGBB integer, as the
 * .synth's `color` does; 0 or absent means no colour was chosen and the bookmark keeps its default look.
 */

export const BOOKMARK_COLORS: ReadonlyArray<{ value: number; name: string }> = [
  { value: 0xFFFF00, name: 'Yellow' },
  { value: 0xFFA500, name: 'Orange' },
  { value: 0xFF0000, name: 'Red' },
  { value: 0x00FFFF, name: 'Light blue' },
  { value: 0x0080FF, name: 'Medium blue' },
  { value: 0x0000FF, name: 'Blue' },
  { value: 0xFF86FF, name: 'Light pink' },
  { value: 0xFF00FF, name: 'Hot pink' },
  { value: 0x8000FF, name: 'Purple' },
  { value: 0xB1E708, name: 'Mint green' },
  { value: 0x00FF00, name: 'Green' },
  { value: 0x03AC13, name: 'Dark green' },
  { value: 0xFFFFFF, name: 'White' },
  { value: 0x818181, name: 'Light grey' },
  { value: 0x333333, name: 'Dark grey' },
];

/** '#RRGGBB' for a stored bookmark colour, or null when the bookmark has none. */
export function bookmarkColorHex(value: number | undefined): string | null {
  if (!value) return null;
  return `#${(value & 0xFFFFFF).toString(16).padStart(6, '0').toUpperCase()}`;
}
